document.addEventListener('DOMContentLoaded', function () {

  function filterByColor(colorValue) {
    var items = document.querySelectorAll('.product__media-item');
    items.forEach(function (item) {
      var img = item.querySelector('img');
      if (!img) return;
      var alt = (img.getAttribute('alt') || '').trim().toLowerCase();
      var color = (colorValue || '').trim().toLowerCase();
      if (alt === '' || alt === color) {
        item.style.display = '';
      } else {
        item.style.display = 'none';
      }
    });
  }

  // Auf Radio-Input-Änderung reagieren (Swatch = versteckter Radio-Button)
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (input.type !== 'radio') return;

    // Nur Farb-Option (erste Option = Farbe)
    var name = input.name || '';
    if (!name.toLowerCase().includes('farbe') && !name.toLowerCase().includes('color') && !name.toLowerCase().includes('option1')) return;

    filterByColor(input.value);
  });

  // Beim Laden: bereits ausgewählte Farbe anwenden
  setTimeout(function () {
    var checked = document.querySelector('input[type="radio"]:checked');
    if (checked) filterByColor(checked.value);
  }, 300);

});